var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('div',{staticClass:"block-loading",class:_vm.mask ? 'mask' : ''},[_c('van-loading',{attrs:{"color":"#009999"}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }